import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { StoreService } from 'services';
import { initSentry } from 'services/sentry';
import Routers from 'router/Routers';
import 'services/i18n';
import './index.css';
import React from 'react';
import ThemeProvider from 'shared/theme/ThemeProvider';
import { LayoutProvider } from 'contexts/LayoutContext';
import { LocaleConfigProvider } from './contexts/LocaleConfigContext';
import { store } from './store';
import StyledGlobal from './Global.styled';

StoreService.setStore(store);
initSentry();

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ThemeProvider>
      <StyledGlobal />
      <LocaleConfigProvider>
        <LayoutProvider>
          <Routers />
        </LayoutProvider>
      </LocaleConfigProvider>
    </ThemeProvider>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
